import clsx from 'clsx'

import FilterGroup from '@/ts/interfaces/global/FilterGroup'
import css from '@/views/common/Presentation/scss/index.module.scss'

import CategoryTags from './includes/CategoryTags'
import CreatorTag from './includes/CreatorTags'
import PriceTags from './includes/PriceTags'

function Tags({ filters }: { filters: FilterGroup }) {
  return (
    <div className={clsx(css.tags, 'scrollbar-hidden')}>
      <CreatorTag />
      <PriceTags />
      <CategoryTags filters={filters} />
    </div>
  )
}

export default Tags
